export const journeyTypeOptions = [
  { text: 'Single', value: 'single' },
  { text: 'Return', value: 'return' },
]
